import React, { Component } from 'react';
import { GeckoCard, Spinner} from '../../components';
import { Auth, ClientManager } from '../../services';

export class HoldingPage extends Component {
    componentDidMount()
    {
        ClientManager.clear();

        // Mobile apps have an issue where their web views are staying logged in.
        // so we should log out of cognito at this point so a Web View reload
        // would let the app begin the authentication process again.
        Auth.destroy();
    }

    render() {
        return (
            <GeckoCard padded={true}>
                <div className="row text mt-3 mb-3">
                    <div className="col d-flex flex-column align-items-center">
                        <Spinner size="small" color="blue" />
                    </div>
                </div>
            </GeckoCard>
        );
    }
}

export default HoldingPage;
